import { IconButton, IconButtonProps } from '@radix-ui/themes';

import styles from './SearchBar.module.css';

export type SlotMode = 'icon' | 'button' | undefined;

export interface SearchBarSlotProps extends IconButtonProps {
    as?: SlotMode;
}

export const SearchBarSlot = ({
    as,
    children,
    ...props
}: SearchBarSlotProps) => {
    if (as === 'button') {
        return (
            <IconButton
                className={styles.slot}
                variant='ghost'
                type='submit'
                {...props}
            >
                {children}
            </IconButton>
        );
    }

    return <>{children}</>;
};
